import { useSelector, useDispatch } from 'react-redux';
import FJMobileSimplePreviewModal from './FJMobileSimplePreviewModal';
import FJActionModal from '../../../redux/action/FJActionModal';
import useLocalStore from '../../../hooks/useLocalStore';

const FJMobileSimplePreviewModalContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const mobileSimplePreviewData = useSelector(state => state.modals.mobileSimplePreviewData);
    const { display, data = {} } = mobileSimplePreviewData;

    const onClose = () => {
        dispatch(FJActionModal.hideMobileSimplePreviewModalAction());
    };

    return <FJMobileSimplePreviewModal visible={display} onClose={onClose} data={data} />;
};
export default FJMobileSimplePreviewModalContainer;
